import React from "react";
import { Link } from "react-router-dom";
import styled from "@emotion/styled";
import * as Yup from "yup";
import { Formik } from "formik";

import {
  Alert as MuiAlert,
  Button,
  TextField as MuiTextField,
} from "@mui/material";
import { spacing } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import { resetPasswordFun, reset } from "../../redux/slices/resetPassword";

const Alert = styled(MuiAlert)(spacing);

const TextField = styled(MuiTextField)(spacing);
const timeOut = (time) => new Promise((res) => setTimeout(res, time));

function ResetPassword() {
  const dispatch = useDispatch();
  const { data } = useSelector((state) => state.reset_password);
  const smtp_id = localStorage.getItem("awlid");

  React.useEffect(() => {
    dispatch(reset());
  }, [dispatch]);

  return (
    <Formik
      initialValues={{
        email: "",
        submit: false,
      }}
      validationSchema={Yup.object().shape({
        email: Yup.string()
          .email("Must be a valid email")
          .max(255)
          .required("Email is required"),
      })}
      onSubmit={async (
        values,
        { resetForm, setErrors, setStatus, setSubmitting }
      ) => {
        try {
          var payload = {
            email: values.email,
            smtp_id: smtp_id,
          };
          await timeOut(1500);
          await dispatch(resetPasswordFun(payload));
          resetForm();
          setStatus({ sent: true });
          setSubmitting(false);
        } catch (error) {
          const message = error.message || "Something went wrong";

          setStatus({ success: false });
          setErrors({ submit: message });
          setSubmitting(false);
        }
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        handleSubmit,
        isSubmitting,
        touched,
        values,
      }) => (
        <form noValidate onSubmit={handleSubmit}>
          {errors.submit && (
            <Alert mt={2} mb={1} severity="warning">
              {errors.submit}
            </Alert>
          )}

          {!!data && !!data.status && parseInt(data.status) !== 200 && (
            <Alert severity="error" my={3}>
              {!!data && data.message}
            </Alert>
          )}

          {!!data && !!data.status && parseInt(data.status) === 200 && (
            <Alert severity="success" my={3}>
              Email sent successfully!
            </Alert>
          )}
          <TextField
            type="email"
            name="email"
            label="Email Address"
            value={values.email}
            error={Boolean(touched.email && errors.email)}
            fullWidth
            helperText={touched.email && errors.email}
            onBlur={handleBlur}
            onChange={handleChange}
            my={3}
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="primary"
            disabled={isSubmitting}
          >
            Reset password
          </Button>
          <Button component={Link} to="/" fullWidth color="primary">
            Login
          </Button>
        </form>
      )}
    </Formik>
  );
}

export default ResetPassword;
